export default __webpack_public_path__ + "static/media/CV-Corinne-Pradier-fr.0c4b21a7.pdf";